import { Button, Card, Input } from "@rumbledirect/ui";
import { Form, Space, Divider, Alert, Typography } from "antd";

const { Text } = Typography;

export const ClaimRankingPreviewCard = () => {
  return (
    <Card title="Voorbeeld">
      <Text type="secondary">
        Vul een postcode en huisnummer in en klik op “Genereer voorbeeld”. De
        demo gebruikt de huidige wegingen om een representatieve ranking van
        locaties te tonen.
      </Text>

      <Divider />

      <Form layout="vertical">
        <Space style={{ width: "100%" }} wrap>
          <Form.Item
            label="Postcode"
            name="postcode"
            rules={[{ required: true, message: "Postcode is verplicht" }]}
          >
            <Input placeholder="Bijv. 2132MS" style={{ width: 140 }} />
          </Form.Item>

          <Form.Item
            label="Huisnummer"
            name="houseNumber"
            rules={[{ required: true, message: "Huisnummer is verplicht" }]}
          >
            <Input placeholder={"60"} style={{ width: 120 }} />
          </Form.Item>
        </Space>

        <Button type="primary" htmlType="submit">
          Genereer voorbeeld
        </Button>
      </Form>

      <Divider />

      <Alert
        className="mt-8"
        showIcon
        type={"warning"}
        message="Geen herstellers gekoppeld"
        description="Er zijn momenteel geen herstellers gekoppeld aan deze omgeving. Gebruik de importeer functie om herstellers uit stamgegevens toe te voegen."
      />
    </Card>
  );
};
